var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{ref:"form",attrs:{"action":"https://codepen.io/pen/define/","method":"POST","target":"_blank"}},[_c('input',{attrs:{"type":"hidden","name":"data"},domProps:{"value":_vm.value}})])}
var staticRenderFns = []

export { render, staticRenderFns }